import { render, staticRenderFns } from "./chapters-list.vue?vue&type=template&id=1d294ed7&scoped=true"
import script from "./chapters-list.vue?vue&type=script&lang=js"
export * from "./chapters-list.vue?vue&type=script&lang=js"
import style0 from "./chapters-list.vue?vue&type=style&index=0&id=1d294ed7&prod&scoped=true&lang=css"
import style1 from "./chapters-list.vue?vue&type=style&index=1&id=1d294ed7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d294ed7",
  null
  
)

export default component.exports